import { GridColumn } from 'src/components/GridWrapper';
import GLCodeLabelCell from 'src/components/custom-cells/GLCodeLabelCell';
import LineItemLabelCell from 'src/components/custom-cells/LineItemLabelCell';
import VarianceCell from 'src/sections/variance_details/VarianceCell';
import AccountingPeriodWarningCell from 'src/sections/variance_details/variance-design-cells/AccountingPeriodWaringCell';
import VarianceGLCodeColumnsCell from 'src/sections/variance_details/variance-design-cells/VarianceGLCodeColumnsCell';
import VarianceGLCodeHeaderCell from 'src/sections/variance_details/variance-design-cells/VarianceGLCodeHeaderCell';
import VarianceGLPeriodColumnsCell from 'src/sections/variance_details/variance-design-cells/VarianceGLPeriodColumnsCell';
import VarianceGLPeriodHeaderCell from 'src/sections/variance_details/variance-design-cells/VarianceGLPeriodHeaderCell';
import { validateNumber } from './VarianceLineItemColumns';

export const varianceGLPeriodColumns: GridColumn<any>[] = [
  {
    field: 'expanded',
    width: 45,
    menu: false,
    sortable: false,
    headerCell: VarianceGLPeriodHeaderCell,
    component: VarianceGLPeriodColumnsCell,
    minResizableWidth: 45,
  },
  {
    field: 'acctPeriod',
    title: 'Accounting Period',
    menu: false,
    component: AccountingPeriodWarningCell,
    width: 349,
    minResizableWidth: 250,
  },
  {
    field: 'poQty',
    title: 'PO Qty',
    filter: 'numeric',
    format: '{0:n2}',
    dataType: 'number',
    minResizableWidth: 100,
  },
  {
    field: 'docQty',
    title: 'Doc Qty',
    filter: 'numeric',
    format: '{0:n2}',
    dataType: 'number',
    component: VarianceCell('hasQtyVariance'),
    minResizableWidth: 100,
  },
  {
    field: 'qtyVariance',
    title: 'Qty Variance',
    filter: 'numeric',
    format: '{0:n2}',
    dataType: 'number',
    specificStyle: validateNumber,
    minResizableWidth: 100,
  },
  {
    field: 'poSubTotal',
    title: 'PO $',
    filter: 'numeric',
    format: '{0:c2}',
    filterFormat: 'c2',
    dataType: 'dollar',
    minResizableWidth: 100,
  },
  {
    field: 'docSubTotal',
    title: 'Doc $',
    filter: 'numeric',
    format: '{0:c2}',
    filterFormat: 'c2',
    dataType: 'dollar',
    component: VarianceCell('hasSubTotalVariance'),
    minResizableWidth: 100,
  },
  {
    field: 'subTotalVariance',
    title: '$ Var',
    filter: 'numeric',
    format: '{0:c2}',
    filterFormat: 'c2',
    dataType: 'dollar',
    specificStyle: validateNumber,
    width: 150,
    minResizableWidth: 100,
  },
];

export const varianceGLCodeColumns: GridColumn<any>[] = [
  {
    field: 'expanded',
    width: 42,
    menu: false,
    sortable: false,
    headerCell: VarianceGLCodeHeaderCell,
    component: VarianceGLCodeColumnsCell,
  },
  {
    field: 'glCd',
    title: 'GL Code',
    filter: 'text',
    dataType: 'string',
    menu: false,
    width: 307,
    component: GLCodeLabelCell,
  },
  {
    field: 'poQty',
    title: 'PO Qty',
    filter: 'numeric',
    format: '{0:n2}',
    dataType: 'number',
    menu: false,
  },
  {
    field: 'docQty',
    title: 'Doc Qty',
    filter: 'numeric',
    format: '{0:n2}',
    dataType: 'number',
    component: VarianceCell('hasQtyVariance'),
    menu: false,
  },
  {
    field: 'qtyVariance',
    title: 'Qty Variance',
    filter: 'numeric',
    format: '{0:n2}',
    dataType: 'number',
    specificStyle: validateNumber,
    menu: false,
  },
  {
    field: 'poSubTotal',
    title: 'Po $',
    filter: 'numeric',
    format: '{0:c2}',
    filterFormat: 'c2',
    dataType: 'dollar',
    menu: false,
  },
  {
    field: 'docSubTotal',
    title: 'Doc $',
    filter: 'numeric',
    format: '{0:c2}',
    filterFormat: 'c2',
    dataType: 'dollar',
    component: VarianceCell('hasSubTotalVariance'),
    menu: false,
  },
  {
    field: 'subTotalVariance',
    title: 'Qty Variance',
    filter: 'numeric',
    format: '{0:c2}',
    filterFormat: 'c2',
    dataType: 'dollar',
    specificStyle: validateNumber,
    menu: false,
    width: 150,
  },
];

export const varianceGLCodeSubColumns: GridColumn<any>[] = [
  {
    field: 'item',
    title: 'Line Items',
    menu: false,
    filter: 'text',
    dataType: 'string',
    width: 307.8,
    minResizableWidth: 250,
    component: LineItemLabelCell,
  },
  {
    field: 'poQty',
    title: 'PO Qty',
    filter: 'numeric',
    format: '{0:n2}',
    dataType: 'number',
    menu: false,
  },
  {
    field: 'docQty',
    title: 'Doc Qty',
    filter: 'numeric',
    format: '{0:n2}',
    dataType: 'number',
    component: VarianceCell('hasQtyVariance'),
    menu: false,
  },
  {
    field: 'qtyVariance',
    title: 'Qty Variance',
    filter: 'numeric',
    format: '{0:n2}',
    dataType: 'number',
    specificStyle: validateNumber,
    menu: false,
  },
  {
    field: 'poSubTotal',
    title: 'Po $',
    filter: 'numeric',
    format: '{0:c2}',
    filterFormat: 'c2',
    dataType: 'dollar',
    menu: false,
  },
  {
    field: 'docSubTotal',
    title: 'Doc $',
    filter: 'numeric',
    format: '{0:c2}',
    filterFormat: 'c2',
    dataType: 'dollar',
    component: VarianceCell('hasSubTotalVariance'),
    menu: false,
  },
  {
    field: 'subTotalVariance',
    title: 'Qty Variance',
    filter: 'numeric',
    format: '{0:c2}',
    filterFormat: 'c2',
    dataType: 'dollar',
    specificStyle: validateNumber,
    menu: false,
    width: 150,
  },
];
